import { stats, testimonials } from "@/mocks/home";

export default function StatsAndTestimonials() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-14 md:mb-20">
          {stats.map((stat, i) => (
            <div key={i} className="text-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                {stat.value}
              </div>
              <div className="mt-1.5 text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div>
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              用户口碑
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              听听我们的用户怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-sm" />
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">
                      {t.name}
                    </div>
                    <div className="text-xs text-foreground-500">{t.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}